var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('h1',{staticClass:"mx-auto"},[_vm._v("Creador de curriculums por")]),_c('img',{attrs:{"src":require("@/assets/logo2.png"),"width":"500"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }